/* global HTMLUpdateUtility, fetchShopifyGraphQL */

/**
 * 问卷结果产品推荐组件
 * 根据用户问卷答案匹配并展示推荐产品
 */

// 问卷路径到产品映射配置
const _allowRoutes = [
  {
    path: [
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Generous budget'
    ],
    productHandle: 'reverse-osmosis-system-x12'
  },
  {
    path: [
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Moderate budget'
    ],
    productHandle: 'remineralization-ro-system-g3p600'
  },
  {
    path: ['Reverse Osmosis', 'Under the sink', 'Standard filtration', 'Moderate budget'],
    productHandle: 'reverse-osmosis-system-x8'
  },
  {
    path: ['Reverse Osmosis', 'Under the sink', 'Standard filtration', 'Tight budget'],
    productHandle: 'waterdrop-reverse-osmosis-water-filtration-system'
  },
  {
    path: ['Reverse Osmosis', 'Under the sink', 'Instant Hot'],
    productHandle: 'reverse-osmosis-instant-hot-water-dispenser-system-wd-k6-w'
  },
  {
    path: ['Reverse Osmosis', 'On the counter', 'Instant Hot', 'Generous budget'],
    productHandle: 'ro-hot-cold-water-dispenser-a1'
  },
  {
    path: ['Reverse Osmosis', 'On the counter', 'Instant Hot', 'Moderate budget'],
    productHandle: 'instant-hot-water-reverse-osmosis-system-wd-k19-h'
  },
  {
    path: ['Reverse Osmosis', 'On the counter', 'Instant Hot', 'Tight budget'],
    productHandle: 'countertop-instant-hot-ro-system-corero-system-c1h'
  },
  {
    path: ['Reverse Osmosis', 'On the counter', 'Instant Hot and Cold', 'Moderate budget'],
    productHandle: 'reverse-osmosis-hot-and-cold-water-dispenser-a2'
  },
  {
    path: ['Reverse Osmosis', 'On the counter', 'Standard filtration', 'Tight budget'],
    productHandle: 'countertop-instant-hot-m1-ro-dispenser'
  },
  {
    path: ['Ultrafiltration', 'Moderate budget'],
    productHandle: '3-stage-ultra-filtration-under-sink-water-filter-system'
  },
  {
    path: ['Ultrafiltration', 'Tight budget'],
    productHandle: 'under-sink-ultrafiltration-water-filter-direct-connect-filtration-system'
  },
  {
    path: ['Carbon Filtration', 'Under the sink', 'Generous budget'],
    productHandle: 'under-counter-filtration-tsa'
  },
  {
    path: ['Carbon Filtration', 'Under the sink', 'Moderate budget'],
    productHandle: 'undersink-water-filtration-system-with-dedicated-faucet'
  },
  {
    path: ['Carbon Filtration', 'Under the sink', 'Tight budget'],
    productHandle: 'under-sink-water-filter-direct-connect-filtration-system'
  },
  {
    path: [
      'Carbon Filtration',
      'On the counter',
      'Faucet water filters',
      'Generous budget'
    ],
    productHandle: 'faucet-water-filtration-system-wd-ctf-01'
  },
  {
    path: [
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Tight budget'
    ],
    productHandle: 'alkaline-ro-water-purifier-g5p500a'
  },
  {
    path: [
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Tight budget'
    ],
    productHandle: 'alkaline-ro-water-filter-for-tap-g5p700a'
  },
  {
    path: [
      'Reverse Osmosis',
      'On the counter',
      'Mineral or alkaline water',
      'Moderate budget'
    ],
    productHandle: 'remineralization-hot-cold-ro-dispenser-a2g'
  },
  {
    path: ['Reverse Osmosis', 'Under the sink', 'Standard filtration', 'Moderate budget'],
    productHandle: 'tankless-reverse-osmosis-system-g3p800'
  },
  {
    path: [
      'Reverse Osmosis',
      'Under the sink',
      'Mineral or alkaline water',
      'Moderate budget'
    ],
    productHandle: 'waterdrop-g3p800-alkaline-reverse-osmosis-system'
  },
  {
    path: [
      'Reverse Osmosis',
      'On the counter',
      'Mineral or alkaline water',
      'Tight budget'
    ],
    productHandle: 'waterdrop-k19-hg-instant-hot-water-reverse-osmosis-system'
  },
  {
    path: [
      'Carbon Filtration',
      'On the counter',
      'Electric Water Filter Pitchers',
      'Tight budget'
    ],
    productHandle: 'instant-hot-cold-countertop-water-filter-dispenser-ct01'
  }
]

/**
 * 生成根据产品 handle 查询的 GraphQL 语句
 * @param {string} productHandle - 产品 handle
 * @returns {string} GraphQL 查询字符串
 */
function productByHandleGQL(productHandle) {
  return `#graphql
  query ProductByHandleUk @inContext(country: GB) {
    product(handle: "${productHandle}") {
      id
      handle
      title
      availableForSale
      onlineStoreUrl
      selectedOrFirstAvailableVariant {
        id
        price {
          amount
        }
        image {
          url
          altText
        }
        metafields(
          identifiers: [
            { key: "variant_price_discount", namespace: "custom" }
            { key: "variant_discount_code", namespace: "custom" }
            { key: "show_percentage_amount", namespace: "custom" }
          ]
        ) {
          value
        }
      }
    }
  }`
}

/**
 * 问卷结果展示组件
 */
class WDQuizResult extends HTMLElement {
  constructor() {
    super()

    this.productContainer = null
    this.sellingPointsPlaceholder = null

    this.sectionId = null

    this.fetchAbortController = null
  }

  connectedCallback() {
    this.initializeQuizResult()
    this.loadProductInfo()
  }

  disconnectedCallback() {
    this.abortPendingRequests()
  }

  /**
   * 初始化组件 DOM 引用
   */
  initializeQuizResult() {
    this.productContainer = this.querySelector('.quiz-answer-result-product')
    this.sellingPointsPlaceholder = this.querySelector('.quiz-answer-result-selling-points')

    this.sectionId = this.dataset.sectionId || null
  }

  /**
   * 取消进行中的请求
   */
  abortPendingRequests() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort()
      this.fetchAbortController = null
    }
  }

  /**
   * 根据问卷路径匹配对应的产品 handle 列表（同 path 可多商品，顺序与 `_allowRoutes` 一致、`productHandle` 去重）
   * @param {string[]} quizPath - 用户问卷答案路径
   * @returns {string[]}
   */
  matchProductHandles(quizPath) {
    if (!quizPath || !Array.isArray(quizPath) || quizPath.length === 0) return []

    /** @type {string[]} */
    const handles = []
    const seen = new Set()

    for (const route of _allowRoutes) {
      if (!this.isPathMatched(quizPath, route.path)) continue
      const h = route.productHandle
      if (!h || seen.has(h)) continue
      seen.add(h)
      handles.push(h)
    }

    return handles
  }

  /**
   * 检查用户路径是否与配置路径完全匹配
   * @param {string[]} userPath - 用户选择的路径
   * @param {string[]} routePath - 配置的路径
   * @returns {boolean} 是否匹配
   */
  isPathMatched(userPath, routePath) {
    if (!Array.isArray(userPath) || !Array.isArray(routePath)) return false
    if (userPath.length !== routePath.length) return false
    return userPath.every((item, index) => item === routePath[index])
  }

  /**
   * 路径无法匹配结果时，清除本地答案并跳转重新作答
   */
  redirectToRetakeQuiz() {
    const quizId = this.dataset.quizId || 'quiz'
    try {
      localStorage.removeItem(`WD-${quizId}`)
    } catch (error) {
      console.warn('Failed to clear quiz path:', error)
    }

    const url = this.dataset.quizUrl || '/pages/find-your-water-filter'
    window.location.href = url
  }

  /**
   * 加载并显示产品信息
   */
  async loadProductInfo() {
    if (!this.productContainer) return

    const quizId = this.dataset.quizId || 'quiz'
    let storedValue = localStorage.getItem(`WD-${quizId}`)
    let isFromTagArr = false
    // 兼容：如果 WD-quizId 不存在，尝试从 tagArr 获取
    if (!storedValue) {
      const tagArrValue = localStorage.getItem('tagArr')
      if (tagArrValue) {
        storedValue = tagArrValue
        isFromTagArr = true
      } else {
        this.redirectToRetakeQuiz()
        return
      }
    }

    // 从 localStorage 解析问卷路径
    let quizPath
    try {
      if (isFromTagArr) {
        // tagArr 未经过 base64 编码，直接解析 JSON
        quizPath = JSON.parse(storedValue)
        // 如果是从 tagArr 获取的，移除数组最后一位（zip-code）
        if (Array.isArray(quizPath) && quizPath.length > 0) quizPath = quizPath.slice(0, -1)
      } else {
        // WD-quizId 是 base64 编码的
        quizPath = JSON.parse(decodeURIComponent(atob(storedValue)))
      }
    } catch (error) {
      console.error('Failed to parse quiz path:', error)
      this.redirectToRetakeQuiz()
      return
    }

    if (!quizPath || quizPath.length === 0) {
      this.redirectToRetakeQuiz()
      return
    }

    const productHandles = this.matchProductHandles(quizPath)
    if (!productHandles.length) {
      console.warn('No matching product handles found for path:', quizPath)
      this.redirectToRetakeQuiz()
      return
    }

    try {
      await this.fetchAndDisplayProducts(productHandles)
    } catch (error) {
      console.error('Failed to load product:', error)
      this.showEmptyState()
    }
  }

  /** 移除为多商品克隆的结果块，保留主题首组 */
  removeExtraResultBlocks() {
    this.querySelectorAll(
      '.quiz-answer-result-product[data-quiz-result-extra], .quiz-answer-result-selling-points[data-quiz-result-extra]'
    ).forEach(el => el.remove())
  }

  /**
   * 按商品个数克隆首组结果块，保持 product / selling points 交错排列
   * @param {number} count
   */
  ensureResultBlockCount(count) {
    this.removeExtraResultBlocks()
    const host = /** @type {HTMLElement} */ (this)
    const loader = host.querySelector('.quiz-answer-result-product__loading')
    const firstProduct = host.querySelector('.quiz-answer-result-product')
    const firstSellingPoints = host.querySelector('.quiz-answer-result-selling-points')
    if (!firstProduct || !firstSellingPoints || !loader) return

    for (let i = 1; i < count; i++) {
      const productClone = /** @type {HTMLElement} */ (firstProduct.cloneNode(true))
      const sellingPointsClone = /** @type {HTMLElement} */ (firstSellingPoints.cloneNode(true))

      productClone.setAttribute('data-quiz-result-extra', 'true')
      productClone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'))

      sellingPointsClone.setAttribute('data-quiz-result-extra', 'true')
      sellingPointsClone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'))
      sellingPointsClone.innerHTML = ''

      loader.before(productClone)
      loader.before(sellingPointsClone)
    }

    this.productContainer = host.querySelector('.quiz-answer-result-product')
    this.sellingPointsPlaceholder = host.querySelector('.quiz-answer-result-selling-points')
  }

  /**
   * 清理单张产品卡片的动态状态，避免重复渲染时残留上一款商品信息
   * @param {HTMLElement} root
   */
  resetProductCard(root) {
    const titleEl = root.querySelector('.quiz-answer-result__title')
    const productLink = root.querySelector('.quiz-answer-result__links .quiz-answer-result__link')
    const currentPriceEl = root.querySelector('.quiz-answer-result__current-price')
    const originalPriceEl = root.querySelector('.quiz-answer-result__original-price')
    const badgeEl = root.querySelector('.quiz-answer-result__badge')
    const discountCodeEl = root.querySelector('.quiz-answer-result__sale-code-value')
    const discountButton = root.querySelector('.component-product-card__discount-code-button')
    const buyButton = root.querySelector('.quiz-answer-result__button-buy')
    const cartButton = root.querySelector('.component-atc-button[data-atc-button]')
    const cartBase = window.routes?.cart_url || '/cart'

    if (titleEl) titleEl.textContent = ''
    if (productLink) productLink.href = '#'
    if (currentPriceEl) currentPriceEl.textContent = ''
    if (originalPriceEl) originalPriceEl.textContent = ''
    if (badgeEl) badgeEl.textContent = ''

    root.querySelectorAll('.quiz-answer-result__image_src').forEach(imgEl => {
      imgEl.removeAttribute('src')
      imgEl.alt = ''
      if (imgEl.parentElement instanceof HTMLAnchorElement) imgEl.parentElement.href = '#'
    })

    if (discountCodeEl) discountCodeEl.textContent = ''
    if (discountButton) {
      discountButton.classList.add('hidden')
      discountButton.ariaHidden = true
      discountButton.dataset.value = ''
    }

    if (buyButton) {
      buyButton.classList.remove('hidden')
      buyButton.href = cartBase
    }

    if (cartButton) {
      cartButton.classList.remove('component-atc-button--sold-out', 'loading')
      cartButton.disabled = false
      cartButton.setAttribute('aria-disabled', 'false')
      cartButton.textContent = cartButton.dataset.atcText || 'Add To Cart'
      cartButton.dataset.atcId = ''
      cartButton.dataset.atcQty = '1'
      delete cartButton.dataset.atcAvailable
      delete cartButton.dataset.atcInventory
    }
  }

  /**
   * 清理单个 selling points 容器，避免多商品或重复渲染时残留上一款商品内容
   * @param {HTMLElement} [root]
   */
  resetSellingPoints(root = this.sellingPointsPlaceholder) {
    if (!root) return
    root.innerHTML = ''
  }

  /**
   * 显示空状态
   */
  showEmptyState() {
    this.removeExtraResultBlocks()
    this.productContainer = this.querySelector('.quiz-answer-result-product')
    this.sellingPointsPlaceholder = this.querySelector('.quiz-answer-result-selling-points')
    if (!this.productContainer) return
    this.resetProductCard(this.productContainer)
    this.resetSellingPoints()
    this.classList.remove('loading')
    this.parentElement?.classList?.add?.('empty')
    this.ariaHidden = true
  }

  /**
   * 并行请求并渲染多款匹配商品
   * @param {string[]} productHandles
   */
  async fetchAndDisplayProducts(productHandles) {
    const host = /** @type {HTMLElement} */ (this)

    if (!productHandles.length) {
      this.showEmptyState()
      return
    }

    this.abortPendingRequests()
    this.removeExtraResultBlocks()
    if (this.productContainer) this.resetProductCard(this.productContainer)
    this.resetSellingPoints()

    const gqlController = new AbortController()
    this.fetchAbortController = gqlController

    try {
      const gqlResults = await Promise.allSettled(
        productHandles.map(handle =>
          fetchShopifyGraphQL({ query: productByHandleGQL(handle) }, gqlController.signal).then(data => ({
            handle,
            data
          }))
        )
      )
      if (gqlController.signal.aborted) return

      if (this.fetchAbortController === gqlController) this.fetchAbortController = null

      const validResults = gqlResults.reduce((results, entry) => {
        if (entry.status !== 'fulfilled') {
          if (entry.reason?.name !== 'AbortError') console.warn('Failed to fetch quiz result product:', entry.reason)
          return results
        }

        const product = entry.value.data?.data?.product
        if (!product?.selectedOrFirstAvailableVariant) return results

        results.push({ handle: entry.value.handle, product })
        return results
      }, [])

      if (validResults.length === 0) {
        this.showEmptyState()
        return
      }

      this.ensureResultBlockCount(validResults.length)

      /** @type {NodeListOf<HTMLElement>} */
      const cards = host.querySelectorAll('.quiz-answer-result-product')
      /** @type {NodeListOf<HTMLElement>} */
      const sellingPointsContainers = host.querySelectorAll('.quiz-answer-result-selling-points')

      validResults.forEach((entry, idx) => {
        const root = cards[idx]
        if (!root) return
        this.resetProductCard(root)
        this.updateProductDisplay(entry.product, root)

        const sellingPointsRoot = sellingPointsContainers[idx]
        if (sellingPointsRoot) this.resetSellingPoints(sellingPointsRoot)
      })

      host.classList.remove('loading')
      host.parentElement?.classList?.remove?.('empty')
      host.ariaHidden = false

      const sectionController = new AbortController()
      this.fetchAbortController = sectionController

      Promise.allSettled(
        validResults.map((entry, idx) => {
          const root = sellingPointsContainers[idx]
          return root ? this.renderProductSections(entry.handle, root, sectionController.signal) : Promise.resolve()
        })
      ).finally(() => {
        if (this.fetchAbortController === sectionController) this.fetchAbortController = null
      })
    } catch (error) {
      if (error.name === 'AbortError') return
      throw error
    } finally {
      if (this.fetchAbortController === gqlController) this.fetchAbortController = null
    }
  }

  /**
   * 更新产品显示信息
   * @param {object} product
   * @param {HTMLElement} [root] 单张结果卡片根节点（默认可不传则使用首张）
   */
  updateProductDisplay(product, root = this.productContainer) {
    if (!root || !product.selectedOrFirstAvailableVariant) {
      return
    }

    const variant = product.selectedOrFirstAvailableVariant
    // 提取变体 ID（移除 Shopify GID 前缀）
    const variantId = variant.id.replace('gid://shopify/ProductVariant/', '')

    const titleEl = root.querySelector('.quiz-answer-result__title')
    if (titleEl && product.title) {
      titleEl.textContent = product.title
    }

    const urlEl = root.querySelector('.quiz-answer-result__link')
    if (urlEl && product.onlineStoreUrl) urlEl.href = product.onlineStoreUrl

    this.updateProductImages(product, variant, root)

    if (variant.price) this.updateProductPricing(variant, root)

    this.updateProductButtons(product, variantId, root)
  }

  /**
   * @param {object} product
   * @param {object} variant
   * @param {HTMLElement} [root]
   */
  updateProductImages(product, variant, root = this.productContainer) {
    if (!root) return
    const imgEls = root.querySelectorAll('.quiz-answer-result__image_src')
    if (imgEls.length === 0) return

    // 优先使用变体图片，否则使用产品主图
    const imageUrl = variant.image?.url || product.featuredImage?.url || ''

    imgEls.forEach(imgEl => {
      imgEl.src = imageUrl
      imgEl.alt = product.title || ''
      if (imgEl.parentElement instanceof HTMLAnchorElement) imgEl.parentElement.href = product.onlineStoreUrl || '#'
    })
  }

  /**
   * @param {object} variant
   * @param {HTMLElement} [root]
   */
  updateProductPricing(variant, root = this.productContainer) {
    if (!root) return
    const currentPriceEl = root.querySelector('.quiz-answer-result__current-price')
    const originalPriceEl = root.querySelector('.quiz-answer-result__original-price')
    const badgeEl = root.querySelector('.quiz-answer-result__badge')
    const discountCodeEl = root.querySelector('.quiz-answer-result__sale-code-value')
    const moneyFormat = this.dataset.moneyFormat || '${{amount}}'

    if (!currentPriceEl) return

    const price = Number(variant.price.amount) || 0

    // 解析折扣价格元数据（JSON 格式）
    let discountPriceMetafields = {}
    try {
      if (variant.metafields?.[0]?.value) discountPriceMetafields = JSON.parse(variant.metafields[0].value)
    } catch (error) {
      console.warn('Failed to parse discount price metafields:', error)
    }

    // 提取折扣信息：价格、折扣码、折扣类型
    const discountPrice = Number(discountPriceMetafields.amount) || 0
    const discountCode = variant.metafields?.[1]?.value || ''
    const discountType = variant.metafields?.[2]?.value || ''

    if (discountPrice > 0) {
      const discountAmount = price - discountPrice
      const formattedDiscountPrice = moneyFormat.replace('{{amount}}', discountPrice.toFixed(2))
      const formattedOriginalPrice = moneyFormat.replace('{{amount}}', price.toFixed(2))

      currentPriceEl.textContent = formattedDiscountPrice
      if (originalPriceEl) originalPriceEl.textContent = formattedOriginalPrice

      if (badgeEl && discountType) {
        const discountText =
          discountType === 'amount'
            ? `${moneyFormat.replace('{{amount}}', discountAmount.toFixed(0))} Off`
            : `${Math.floor((discountAmount / price) * 100)}% Off`
        badgeEl.textContent = discountText
      }
    } else {
      currentPriceEl.textContent = moneyFormat.replace('{{amount}}', price.toFixed(2))
    }

    if (!!discountCode && discountCodeEl?.parentElement) {
      const parentEl = discountCodeEl.parentElement
      parentEl.classList.remove('hidden')
      parentEl.ariaHidden = false
      parentEl.dataset.value = discountCode
      discountCodeEl.textContent = discountCode
    }
  }

  /**
   * @param {object} product
   * @param {string} variantId
   * @param {HTMLElement} [root]
   */
  updateProductButtons(product, variantId, root = this.productContainer) {
    if (!root) return
    const buyButton = root.querySelector('.quiz-answer-result__button-buy')
    const cartButton = root.querySelector('.component-atc-button[data-atc-button]')
    if (!buyButton || !cartButton) return

    if (product.availableForSale) {
      buyButton.classList.remove('hidden')
      cartButton.disabled = false
      cartButton.textContent = cartButton.dataset.atcText || 'Add To Cart'
      const cartBase = window.routes?.cart_url || '/cart'
      buyButton.href = cartBase.endsWith('/') ? `${cartBase}${variantId}:1` : `${cartBase}/${variantId}:1`
      cartButton.dataset.atcId = variantId
      cartButton.dataset.atcQty = '1'
    } else {
      buyButton.classList.add('hidden')
      cartButton.textContent = 'Sold Out'
      cartButton.disabled = true
    }
  }

  /**
   * 获取并渲染产品相关区块（selling points）
   * @param {string} productHandle
   * @param {HTMLElement} [root]
   * @param {AbortSignal} [signal]
   * @returns {Promise<void>}
   */
  async renderProductSections(productHandle, root = this.sellingPointsPlaceholder, signal) {
    if (!root) return
    const url = `${this.dataset.requestUrl}/products/${productHandle}`

    try {
      const response = await fetch(url, { signal })
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const responseText = await response.text()
      const html = new DOMParser().parseFromString(responseText, 'text/html')

      const sellingSection = html.querySelector('.product-selling-points-section')
      if (sellingSection) {
        HTMLUpdateUtility.setInnerHTML(root, sellingSection.innerHTML)
      }
    } catch (error) {
      if (error.name !== 'AbortError') console.error('Failed to render product sections:', error)
    }
  }
}

// 注册自定义元素
if (!customElements.get('wd-quiz-result')) {
  customElements.define('wd-quiz-result', WDQuizResult)
}
